var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M24.8 33.3c.2.5.3 1 .3 1.5 0 2.2-1.8 3.9-3.9 3.9s-3.9-1.8-3.9-3.9c0-.5.1-1.1.3-1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M8.7 28.5c.4-1.1 1-2.2 2-3 1.2-1 2.4-1.9 3.5-2.6v-5.8c0-3.9 3.1-7 7-7 1.9 0 3.7.8 4.9 2s2 3 2 4.9v5.8c1.1.8 2.4 1.7 3.6 2.7 3.2 2.6 2.5 7.8 2.5 7.8h-26"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 21.2,
    cy: 4.6,
    r: 2.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.0919e98ec81516d09d5e4941b749828b.svg";
export { ForwardRef as ReactComponent };